import { ReactComponent as ExportBlockedIcon } from 'assets/svgs/export-blocked.svg';
import { ReactComponent as ExportCompletedIcon } from 'assets/svgs/export-completed.svg';
import { ReactComponent as ExportInProgressIcon } from 'assets/svgs/export-inprogress.svg';
import { ReactComponent as ExportTodoIcon } from 'assets/svgs/export-todo.svg';

export const ExportTodo = ExportTodoIcon;
export const ExportInProgress = ExportInProgressIcon;
export const ExportCompleted = ExportCompletedIcon;
export const ExportBlocked = ExportBlockedIcon;
